import { render, staticRenderFns } from "./QuizBankList.vue?vue&type=template&id=aa3214f2&scoped=true"
import script from "./QuizBankList.vue?vue&type=script&lang=js"
export * from "./QuizBankList.vue?vue&type=script&lang=js"
import style0 from "./QuizBankList.vue?vue&type=style&index=0&id=aa3214f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3214f2",
  null
  
)

export default component.exports